import { useDispatch, useSelector } from "react-redux";
import { LeftArrow, RightArrow } from "src/components/svg";
import { _ } from "src/services";
import { TvModel, TvAction } from "src/store";
export const TvModelChannelsToggle: React.FC = () => {

    const dispatch = useDispatch();
    const conductor: TvModel = useSelector((state: any) => state.TvState);
    const { logo, title } = conductor.currentChannel || {};

    const onClick = () => {
        dispatch(TvAction.toggleConductor());
    };

    return (
        <div className="current-channel-item d-flex d-lg-none justify-content-between align-items-center text-rtl text-right px-3 py-2">
            <div>
                <img alt={title} src={logo} className="logo ml-2" />
                <span className="title">{title}</span>
            </div>
            <button className="btn btn-tv d-block py-2 px-3" onClick={onClick}>
                <span className="arrow">
                    {conductor.showConductor && <RightArrow />}
                </span>
                <span className="mx-1">
                    {conductor.showConductor ? _("channelList") : _("programList")}
                </span>
                <span className="arrow">
                    {!conductor.showConductor && <LeftArrow />}
                </span>
            </button>
        </div >
    );

};